export default __webpack_public_path__ + "static/media/location.8595cde2.jpg";